import clsx from 'clsx';
import { Combination, Option } from '@/lib/ecwid/ecwidTypes';
import { getVariants, groupVariants } from '@/lib/ecwid/utils/reshaping';
import { useVariantStore } from '../useVariantStore';

export const VariantSelector = ({
    combinations,
    options,
}: {
    combinations: Combination[];
    options: Option[];
}) => {
    const variants = getVariants(combinations, options);
    const groupedOptions = groupVariants(variants);

    const { selectedVariant, setVariantSelected, initializeVariant } =
        useVariantStore();

    if (variants.length) {
        initializeVariant(variants);
    }

    return (
        <div>
            {Object.entries(groupedOptions).map(([name, choices]) => (
                <div className="mb-2" key={name}>
                    <p className="font-semibold mb-2">{name.toUpperCase()}</p>
                    <div className="flex gap-4 flex-wrap">
                        {choices.map(choice => {
                            const isSelected =
                                selectedVariant?.id === choice.id;
                            const isDisabled = choice.disabled;

                            return (
                                <button
                                    aria-disabled={isDisabled}
                                    className={clsx(
                                        'flex min-w-[48px] items-center justify-center rounded-full border px-3 py-1 text-lg transition duration-300 ease-in-out',
                                        {
                                            // Selected variant
                                            'border-primary-accent bg-primary-accent text-white ring-2 ring-primary-light hover:scale-110':
                                                isSelected,

                                            // Non-selected variant
                                            'border-primary-accent bg-neutral-100 text-neutral-900 hover:bg-primary-light hover:text-white':
                                                !isSelected && !isDisabled,

                                            // Disabled variant
                                            'border-neutral-400 bg-neutral-200 text-neutral-600':
                                                isDisabled,
                                        },
                                    )}
                                    disabled={isDisabled}
                                    key={choice.id}
                                    onClick={() => {
                                        if (!isDisabled) {
                                            setVariantSelected(choice);
                                        }
                                    }}
                                >
                                    {choice.label}
                                </button>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};
